import { render, staticRenderFns } from "./BlockFive.vue?vue&type=template&id=a61399ac&scoped=true&"
import script from "./BlockFive.vue?vue&type=script&lang=js&"
export * from "./BlockFive.vue?vue&type=script&lang=js&"
import style0 from "./BlockFive.vue?vue&type=style&index=0&id=a61399ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a61399ac",
  null
  
)

export default component.exports